import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  useNavigate
} from "react-router-dom";

export default function PushToHome() {
    const navigate = useNavigate();
    useEffect(() => {
        navigate("/");
    }
    , [navigate]);
    return null;
}